/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_AvailabilityInputs */

const en_admin_resource_form_availability = /** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability`)
};

const de_admin_resource_form_availability = /** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit`)
};

const es_admin_resource_form_availability = /** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilidad`)
};

const fr_admin_resource_form_availability = /** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité`)
};

/** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */
const it_admin_resource_form_availability = en_admin_resource_form_availability;

/** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */
const pt_br2_admin_resource_form_availability = en_admin_resource_form_availability;

/** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */
const pl_admin_resource_form_availability = en_admin_resource_form_availability;

/** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */
const hu_admin_resource_form_availability = en_admin_resource_form_availability;

/** @type {(inputs: Admin_Resource_Form_AvailabilityInputs) => LocalizedString} */
const ro_admin_resource_form_availability = en_admin_resource_form_availability;

/**
* | output |
* | --- |
* | "Availability" |
*
* @param {Admin_Resource_Form_AvailabilityInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_availability = /** @type {((inputs?: Admin_Resource_Form_AvailabilityInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_AvailabilityInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_availability(inputs)
	if (locale === "de") return de_admin_resource_form_availability(inputs)
	if (locale === "es") return es_admin_resource_form_availability(inputs)
	if (locale === "fr") return fr_admin_resource_form_availability(inputs)
	if (locale === "it") return it_admin_resource_form_availability(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_availability(inputs)
	if (locale === "pl") return pl_admin_resource_form_availability(inputs)
	if (locale === "hu") return hu_admin_resource_form_availability(inputs)
	return ro_admin_resource_form_availability(inputs)
});
export { admin_resource_form_availability as "admin.resource_form.availability" }